<template>
  <div class="consulAddDialog">
    <div class="basicTitle">天长市农村社区协商办理结果评议单</div>
    <div class="basicSubTitle">社区：{{communityName}}</div>
    <table class="basicTable">
      <tr>
        <th>议题名称</th>
        <th>评议内容</th>
        <th>评议形式</th>
        <th>评议结束</th>
        <th>发布时间</th>
        <th>评议结果运用</th>
        <th>备注</th>
      </tr>
      <tr class="basicTableRight">
        <td class="basicTableRightTd">{{content}}</td>
        <td class="basicTableRightTd">
          <input type="text" style="width:99%;height:99%;border:none;" v-model="pingyiform.commentContent">
        </td>
        <td class="basicTableRightTd">
          <table>
            <tr>
              <th>书面</th>
              <th>微信/QQ</th>
              <th>电话</th>
              <th>会议</th>
              <th>其他</th>
            </tr>
            <tr>
              <td>
                <input name="commentType1" v-model="commentType1" type="checkbox" value="0" />
              </td>
              <td>
                <input name="commentType2" v-model="commentType2" type="checkbox" value="1" />
              </td>
              <td>
                <input name="commentType3" v-model="commentType3" type="checkbox" value="2" />
              </td>
              <td>
                <input name="commentType4" v-model="commentType4" type="checkbox" value="3" />
              </td>
              <td>
                <input name="commentType5" v-model="commentType5" type="checkbox" value="4" />
              </td>
            </tr>
          </table>
        </td>
        <td class="basicTableRightTd">
          <table>
            <tr>
              <th>同意</th>
              <th>不同意</th>
              <th>同意</th>
              <th>不同意</th>
              <th>同意</th>
              <th>不同意</th>
              <th>同意</th>
              <th>不同意</th>
              <th>同意</th>
              <th>不同意</th>
            </tr>
            <tr>
              <td>
                <input name="smCommentResult" v-model="pingyiform.smCommentResult" type="radio" value="0" />
              </td>
              <td>
                <input name="smCommentResult" v-model="pingyiform.smCommentResult" type="radio" value="1" />
              </td>
              <td>
                <input name="wechatCommentResult" v-model="pingyiform.wechatCommentResult" type="radio" value="0" />
              </td>
              <td>
                <input name="wechatCommentResult" v-model="pingyiform.wechatCommentResult" type="radio" value="1" />
              </td>
              <td>
                <input name="phoneCommentResult" v-model="pingyiform.phoneCommentResult" type="radio" value="0" />
              </td>
              <td>
                <input name="phoneCommentResult" v-model="pingyiform.phoneCommentResult" type="radio" value="1" />
              </td>
              <td>
                <input name="meetingCommentResult" v-model="pingyiform.meetingCommentResult" type="radio" value="0" />
              </td>
              <td>
                <input name="meetingCommentResult" v-model="pingyiform.meetingCommentResult" type="radio" value="1" />
              </td>
              <td>
                <input name="qtCommentResult" v-model="pingyiform.qtCommentResult" type="radio" value="0" />
              </td>
              <td>
                <input name="qtCommentResult" v-model="pingyiform.qtCommentResult" type="radio" value="1" />
              </td>
            </tr>
          </table>
        </td>
        <td class="basicTableRightTdFive">
          <table>
            <tr>
              <th>
                <el-date-picker
                  v-model="pingyiform.publishTime"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择日期时间">
                </el-date-picker>
              </th>
              <th>汇总时间</th>
              <th>
                <el-date-picker
                  v-model="pingyiform.summaryTime"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择日期时间">
                </el-date-picker>
              </th>
            </tr>
          </table>
        </td>
        <td class="basicTableRightTdSix">
            <table>
            <tr>
              <th>
                <input type="text" name="commentResult" v-model="pingyiform.commentResult" style="width:99%;height:99%;border:none;">
              </th>
              <th>评议比例分析</th>
              <th>
                <input type="text" name="commentProportion" v-model="pingyiform.commentProportion" style="width:99%;height:99%;border:none;">
              </th>
            </tr>
          </table>
        </td>
        <td class="basicTableRightTd">
           <input type="text" v-model="pingyiform.remarks" style="width:99%;height:99%;border:none;">
        </td>
      </tr>
    </table>
    <div class="pingYiRen">评议人或汇总人：<input type="text" v-model="pingyiform.commentPerson" style="width:99%;height:50px;border:none;"></div>
    <el-form>
    <el-form-item label="审核结果：">
      <el-radio v-model="approvalStatus" label="0">审核通过</el-radio>
      <el-radio v-model="approvalStatus" label="1">审核不通过</el-radio>
    </el-form-item>
    <el-form-item label="审核意见：">
      <el-input v-model="approvalOpinion" type="textarea"></el-input>
    </el-form-item>
    </el-form>
    <div class="queRenBtn">
      <el-button type="primary" style='margin: 0 30px' @click="onSave">确认</el-button>
      <el-button type="info"  @click="quxiao">取消</el-button>
    </div>
  </div>
</template>

<script>
import { post } from "@/api/requrestHttp";
export default {
  props: ["ytid"],
  data() {
    return {
      id: this.ytid,
      radio: "1",
      consultName: '',
      content: '',
      communityName: '',
      commentContent: '',
      commentType1: false,
      commentType2: false,
      commentType3: false,
      commentType4: false,
      commentType5: false,
      pingyiform: {
        commentType: ""
      },
      commentTypeList: [],
      approvalStatus: '',
      approvalOpinion: ''
    };
  },
  methods: {
    getFindConsultById() {
      post("/admin/consult/info/findConsultById",{
        id: this.ytid
      }).then(res => {
        console.log(res)
        this.consultName = res.content.consultName;
        this.content = res.content.content;
        console.log(res.content.communityId)
        if(res.content.communityId == '2') {
          this.communityName = '浔河社区'
        }else if(res.content.communityId == '20') {
          this.communityName = '石街社区'
        }
      })
    },
    getData() {
      this.approvalStatus = "";
      this.approvalOpinion = "";
      this.pingyiform = {};
      this.commentTypeList = [];
    },
    getConsultComment() {
      this.commentTypeList = [];
      this.pingyiform = {};
      post("/admin/consultComment/info/getConsultComment",{
        consultId: this.ytid
      }).then(res => {
        console.log(res)
        this.commentContent = res.content.commentContent;
        console.log(res.content.commentContent)
        this.pingyiform = res.content;
        console.log(this.pingyiform.commentType)
        this.commentTypeList = res.content.commentType.split(',');
        console.log(this.commentTypeList)
        let index1 = this.commentTypeList.indexOf('0');
        let index2 = this.commentTypeList.indexOf('1');
        let index3 = this.commentTypeList.indexOf('2');
        let index4 = this.commentTypeList.indexOf('3');
        let index5 = this.commentTypeList.indexOf('4');
        console.log(index4)
        if(index1 !== -1) {
          this.commentType1 = true;
        }if(index2 !== -1) {
          this.commentType2 = true;
        }if(index3 !== -1) {
          this.commentType3 = true;
        }if(index4 !== -1) {
          this.commentType4 = true;
        }if(index5 !== -1) {
          this.commentType5 = true;
        }
        console.log(this.commentType4)
      })
    },
    onSave() {
      if(this.approvalStatus == '') {
        this.$message.error({
          message:'请选择审核结果'
        })
        return false
      }
      console.log(this.id)
      post("/admin/consultComment/info/updateConsultComment",{
        consultId: this.ytid,
        approvalStatus: this.approvalStatus,
        approvalOpinion: this.approvalOpinion
      }).then(res => {
        console.log(res)
        this.$emit("close")
      })
    },
    quxiao() {
      this.$emit("close");
      this.approvalStatus = "";
      this.approvalOpinion = "";
      this.commentTypeList = [];
      this.pingyiform = {};
    }
  },
  mounted() {
    this.getConsultComment();
    this.getFindConsultById();
  }
};
</script>

<style lang="less" scoped>
.consulAddDialog {
  margin: 40px;
  .el-form-item {
    margin-bottom: 10px;
    .el-form-item__error {
      top: 85%;
    }
  }
}
.basicTitle {
  font-size: 25px;
  text-align: center;
}
.basicSubTitle {
  font-size: 22px;
  margin-bottom: 20px;
}
.queRenBtn {
  margin: 60px 0;
   margin-top: 30px;
  display: flex;
  justify-content: center;
}
.basicTable {
  display: flex;
  flex-direction: row;
  border-right: 1px solid #804040;
  border-bottom: 1px solid #804040;
  border-collapse: collapse;
}
// .basicTable tr:nth-child(1) {
//   width: 15%;
// }
// .basicTable tr:nth-child(2) {
//   width: 85%;
// }
.basicTable tr th {
  height: 60px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-left: 1px solid #804040;
  border-top: 1px solid #804040;
}
.basicTable tr th:nth-child(6) {
  height: 400px;
}
.basicTable tr td:nth-child(6) {
  height: 403px;
}
.basicTable tr td {
  height: 63px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-left: 1px solid #804040;
  border-top: 1px solid #804040;
}
.basicTableRight {
  flex: 1;
}
.basicTableRightTd {
  display: flex;
}
.basicTableRightTd table {
  flex: 1;
  display: flex;
  flex-direction: column;
  width: 100%;
}
.basicTableRightTd {
  display: flex;
  flex-direction: row;
  height: 30px;
  flex: 1;
  box-sizing: border-box;
}
.basicTableRightTd tr {
  display: flex;
  margin-left: -1px;
}
.basicTableRightTd th {
  height: 28px !important;
  flex: 1;
  border-top: none !important;
}
.basicTableRightTd td {
  height: 28px !important;
  flex: 1;
  border: none;
}
.basicTableRightTd tr th:first-child {
  border-left: none !important;
}
.basicTableRightTd tr td:first-child {
  border-left: none !important;
}
.basicTableRightTdFive {
  display: flex;
}
.basicTableRightTdFive table {
  flex: 1;
  display: flex;
  flex-direction: column;
  width: 100%;
}
.basicTableRightTdFive {
  display: flex;
  flex-direction: row;
  height: 30px;
  flex: 1;
  box-sizing: border-box;
}
.basicTableRightTdFive tr {
  display: flex;
  margin-left: -1px;
}
.basicTableRightTdFive th {
  height: 61px !important;
  flex: 1;
  border-top: none !important;
}
.basicTableRightTdFive th:nth-child(2) {
  width: 61px !important;
}
.basicTableRightTdFive tr th:first-child {
  border-left: none !important;
}
.basicTableRightTdFive tr td:first-child {
  border-left: none !important;
}
.basicTableRightTdSix {
  display: flex;
}
.basicTableRightTdSix table {
  flex: 1;
  display: flex;
  flex-direction: column;
  width: 100%;
}
.basicTableRightTdSix {
  display: flex;
  flex-direction: row;
  height: 30px;
  flex: 1;
  box-sizing: border-box;
}
.basicTableRightTdSix tr {
  display: flex;
  margin-left: -1px;
}
.basicTableRightTdSix th {
  height: 401px !important;
  flex: 1;
  border-top: none !important;
}
.basicTableRightTdSix th:nth-child(2) {
  width: 61px !important;
}
.basicTableRightTdSix tr th:first-child {
  border-left: none !important;
}
.basicTableRightTdSix tr td:first-child {
  border-left: none !important;
}
.pingYiRen {
    margin-top: 20px;
    margin-bottom: 20px;
    font-size: 15px;
}
</style>